import React from "react";
import classes from "./CVDownload.module.css";
import { faCloudDownload as faclouddownload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CVDownload = (props) => {
  return (
    <div className={classes.CVButtonDiv} onClick={props.click}>
      <a
        href="https://drive.google.com/uc?export=download&id=1L5X5hodnuNudywMwWoFbiUm4QEAdJ3iv"
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className={classes.CVButton}>
          <FontAwesomeIcon icon={faclouddownload} />
          My CV
        </button>
      </a>
    </div>
  );
};

export default CVDownload;
